'use strict';

import {ewModel} from './ewmodel.js';

export class organizationModel extends ewModel
{
	registration_number = '';
	legal_status_other = false;
	legal_status_other_value = '';
	phone = '';
	phoneInput = '';
	
	constructor(itemData){
		super(itemData);
		this.setupItemData(itemData);
	}
	
	afterSetup(data){
		this.legal_status_other = !!parseInt(this.legal_status_other);
//		if(typeof(this.legal_status) === 'undefined'){
//			this.legal_status = [];
//		}
//		if(typeof(this.legal_status_ids) === 'undefined'){
//			this.legal_status_ids = [];
//		}
//		if(this.legal_status_other && this.legal_status_ids.indexOf('oth') < 0){
//			this.legal_status_ids.push('oth');
//		}
		
		if(this.legal_status_other){
			this.reglegal_status_id = 'oth';
		}
	}
	
	legalStatusOther(on){
		this.legal_status_other = !!on;
		if(this.legal_status_other){
			if(arguments[1]){
				this.legal_status_other_value = arguments[1];
			}
		}
		else{
			this.legal_status_other_value = '';
		}
	}
	
}


